// Shared option sets + labels for lifestyle/housing preferences.
export const CITIES = ["Bangalore", "Pune", "Delhi NCR", "Mumbai", "Hyderabad", "Chennai", "Kolkata", "Ahmedabad"];

export const INTENTS = [
  { key: "find_room", title: "Find a Room", sub: "I want to move into an existing flat.", icon: "DoorOpen" },
  { key: "find_flatmate", title: "Find a Flatmate", sub: "I have a room available and need someone to move in.", icon: "UserPlus" },
  { key: "find_people", title: "Find People", sub: "I want to find people and rent a new place together.", icon: "Users" },
];

export const OPTIONS = {
  gender: [{ v: "male", l: "Male" }, { v: "female", l: "Female" }, { v: "prefer_not", l: "Prefer not to say" }, { v: "other", l: "Other" }],
  employment_status: [{ v: "working", l: "Working" }, { v: "student", l: "Student" }, { v: "self_employed", l: "Self-employed" }, { v: "looking", l: "Looking for work" }, { v: "not_working", l: "Not working" }, { v: "other", l: "Other" }],
  sector: [{ v: "technology", l: "Technology" }, { v: "finance", l: "Finance" }, { v: "consulting", l: "Consulting" }, { v: "healthcare", l: "Healthcare" }, { v: "education", l: "Education" }, { v: "marketing", l: "Marketing" }, { v: "legal", l: "Legal" }, { v: "government", l: "Government" }, { v: "hospitality", l: "Hospitality" }, { v: "manufacturing", l: "Manufacturing" }, { v: "creative", l: "Creative / Media" }, { v: "other", l: "Other" }],
  work_mode: [{ v: "office", l: "From office" }, { v: "hybrid", l: "Hybrid" }, { v: "wfh", l: "From home" }, { v: "flexible", l: "Flexible / irregular" }],
  personal_food: [{ v: "veg", l: "Vegetarian" }, { v: "nonveg", l: "Non-vegetarian" }, { v: "both", l: "Both" }],
  food_comfortable: [{ v: "veg", l: "Vegetarian food" }, { v: "nonveg", l: "Non-vegetarian food" }],
  food_arrangement: [{ v: "self", l: "Self-cooking" }, { v: "maid", l: "Maid / cook available" }, { v: "both", l: "Both" }],
  wake_time: [{ v: "early", l: "Early bird ☀️" }, { v: "normal", l: "Regular" }, { v: "late", l: "Late riser 🌙" }],
  sleep_time: [{ v: "early", l: "Early (before 11)" }, { v: "normal", l: "Around midnight" }, { v: "late", l: "Night owl" }],
  work_schedule: [{ v: "9to5", l: "9 to 5" }, { v: "flexible", l: "Flexible" }, { v: "night", l: "Night shift" }],
  wfh_frequency: [{ v: "never", l: "Never" }, { v: "sometimes", l: "Sometimes" }, { v: "often", l: "Often" }, { v: "always", l: "Always" }],
  food_preference: [{ v: "veg", l: "Vegetarian" }, { v: "nonveg", l: "Non-veg" }, { v: "vegan", l: "Vegan" }, { v: "eggetarian", l: "Eggetarian" }],
  smoking: [{ v: "no", l: "Non-smoker" }, { v: "occasionally", l: "Occasionally" }, { v: "yes", l: "Smoker" }],
  drinking: [{ v: "no", l: "Doesn't drink" }, { v: "occasionally", l: "Socially" }, { v: "yes", l: "Regularly" }],
  pets: [{ v: "love", l: "Love pets 🐾" }, { v: "ok", l: "Okay with pets" }, { v: "no", l: "No pets" }],
  social_lifestyle: [{ v: "introvert", l: "Introvert" }, { v: "ambivert", l: "Ambivert" }, { v: "extrovert", l: "Extrovert" }],
  party_frequency: [{ v: "never", l: "Never" }, { v: "rarely", l: "Rarely" }, { v: "sometimes", l: "Sometimes" }, { v: "often", l: "Often" }],
  noise_preference: [{ v: "quiet", l: "Quiet home" }, { v: "moderate", l: "Moderate" }, { v: "lively", l: "Lively" }],
  guest_preference: [{ v: "rarely", l: "Rarely" }, { v: "sometimes", l: "Sometimes" }, { v: "often", l: "Often" }],
  room_preference: [{ v: "private", l: "Private room" }, { v: "shared", l: "Shared room" }, { v: "any", l: "Any" }],
  gender_preference: [{ v: "any", l: "Any gender" }, { v: "male", l: "Male only" }, { v: "female", l: "Female only" }],
};

export const DISTANCES = [
  { v: 0, l: "Any distance" }, { v: 2, l: "Within 2 km" }, { v: 5, l: "Within 5 km" },
  { v: 10, l: "Within 10 km" }, { v: 20, l: "Within 20 km" },
];

export const AVATARS = [
  "https://api.dicebear.com/7.x/adventurer/svg?seed=Aneka&backgroundColor=b6e3f4",
  "https://api.dicebear.com/7.x/adventurer/svg?seed=Milo&backgroundColor=ffd5dc",
  "https://api.dicebear.com/7.x/adventurer/svg?seed=Zara&backgroundColor=d1d4f9",
  "https://api.dicebear.com/7.x/adventurer/svg?seed=Kabir&backgroundColor=c0aede",
  "https://api.dicebear.com/7.x/adventurer/svg?seed=Riya&backgroundColor=ffdfbf",
  "https://api.dicebear.com/7.x/adventurer/svg?seed=Dev&backgroundColor=b6e3f4",
  "https://api.dicebear.com/7.x/adventurer/svg?seed=Meera&backgroundColor=ffd5dc",
  "https://api.dicebear.com/7.x/adventurer/svg?seed=Arjun&backgroundColor=c0aede",
  "https://api.dicebear.com/7.x/adventurer/svg?seed=Sara&backgroundColor=d1d4f9",
  "https://api.dicebear.com/7.x/adventurer/svg?seed=Vivaan&backgroundColor=ffdfbf",
];

export const LABELS = Object.fromEntries(
  Object.entries(OPTIONS).map(([k, arr]) => [k, Object.fromEntries(arr.map((o) => [o.v, o.l]))])
);

export const AMENITIES = ["WiFi", "AC", "Washing Machine", "Fridge", "Gym", "Parking", "Power Backup", "Balcony", "Housekeeping", "Security", "Swimming Pool", "Sea View"];
export const CONFIGS = ["1BHK", "2BHK", "3BHK", "4BHK", "5BHK"];
export const FURNISHING = [{ v: "full", l: "Fully furnished" }, { v: "semi", l: "Semi-furnished" }, { v: "none", l: "Unfurnished" }];

export const LISTING_TYPES = [
  { key: "room_available", title: "Room available", sub: "You have a room in your flat" },
  { key: "looking_room", title: "Looking for a room", sub: "You want to move into a flat" },
  { key: "looking_flatmate", title: "Looking for a flatmate", sub: "You need someone to move in" },
  { key: "looking_people", title: "People to rent together", sub: "Form a group for a new place" },
];

export function fmtRent(n) {
  if (n == null) return "—";
  return "₹" + Number(n).toLocaleString("en-IN");
}

export function fmtDate(d) {
  if (!d) return "Flexible";
  try {
    return new Date(d).toLocaleDateString("en-IN", { day: "numeric", month: "short" });
  } catch {
    return d;
  }
}
